var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoaderSpinner',{staticClass:"fa-spin loader-icon mx-auto d-block"})
}
var staticRenderFns = []

export { render, staticRenderFns }